import React from 'react';
import { Translate } from '../../../language';
import Input from '../../../utils/components/Input/Input';
import circle from '../../../assets/img/circulogris.png';
import "./ResetPasswordView.css"
import Button from '../../../utils/components/Button/Button';
import localStorage from '../../../utils/hooks/useLocalStorage';
const ResetPasswordView = ({ formik,history,firstName="",secondName="" }) => {
    return <div className='content-resetPassword'>
        <div className="content-picture-resetPassword">
            <img
                alt="img"
                className="profile-picture-img"
                onError={(e) => (e.target.src = circle)}
                src={localStorage().getItem("picturProfile")}
            ></img>
            <div
                style={{ overflow: "auto", overflowY: "hidden" }}
                className="full-name-image-name full-name-resetPassword"
            >
                <div className="first-name-image-name">{firstName}</div>
                <div className="second-name-image-name">{secondName}</div>
            </div>
        </div>
        <div className='content-inputs-resetPassword'>
            <Input
                name="password"
                type="password"
                placeholder={Translate('currentPassword', 'es')}
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.errors.password}
            />
            <Input
                name="newPassword"
                type="password"
                placeholder={Translate('newPassword', 'es')}
                value={formik.values.newPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.errors.newPassword}
            />
            <Input
                name="confirmPassword"
                type="password"
                placeholder={Translate('confirmNewPassword', 'es')}
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.errors.confirmPassword}
            />
        </div>
        <div className='content-btn-resetPassword'>
            <Button onClick={formik.handleSubmit}  text='Guardar' width='60%'/>
            <Button onClick={()=>history.push("/")} text='Cancelar'  width='60%' theme='white' />
        </div>
    </div>;
};

export default ResetPasswordView;
